import { Component, OnInit, viewChild, Signal, inject } from '@angular/core';
import { NgProgressbar, NgProgressRef } from 'ngx-progressbar';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError, RouterModule } from '@angular/router';
import { environment } from 'src/environments/environment';
import { UpdateService } from './shared/services/update/update.service';
import { PosthogService } from './shared/services/posthog.service';

declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterModule, NgProgressbar]
})
export class AppComponent implements OnInit {
  progressBar: Signal<NgProgressRef> = viewChild(NgProgressRef);
  private cancelCompleteTimer: ReturnType<typeof setTimeout> | null = null;
  private navigationInProgress = false;

  private readonly posthogService = inject(PosthogService);

  constructor(
    private router: Router,
    private updateService: UpdateService
  ) { }

  ngOnInit() {
    this.posthogService.init();
    this.updateService.init();
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (this.cancelCompleteTimer) {
          clearTimeout(this.cancelCompleteTimer);
          this.cancelCompleteTimer = null;
        } else if (!this.navigationInProgress) {
          this.progressBar().start();
        }
        this.navigationInProgress = true;
        document.body.classList.remove('dialog-open');
      }
      if (event instanceof NavigationEnd) {
        if (this.cancelCompleteTimer) {
          clearTimeout(this.cancelCompleteTimer);
          this.cancelCompleteTimer = null;
        }
        this.navigationInProgress = false;
        this.progressBar().complete();
        window.scrollTo(0, 0);
      }
      if (event instanceof NavigationCancel) {
        this.cancelCompleteTimer = setTimeout(() => {
          this.cancelCompleteTimer = null;
          this.navigationInProgress = false;
          this.progressBar().complete();
        }, 0);
      }
      if (event instanceof NavigationError) {
        if (this.cancelCompleteTimer) {
          clearTimeout(this.cancelCompleteTimer);
          this.cancelCompleteTimer = null;
        }
        this.navigationInProgress = false;
        this.progressBar().complete();
      }
    })
    // block dashboard analytics (plausible) on dev/staging
    if (environment.name !== 'production') window.localStorage.setItem("plausible_ignore", "true");

  }
}
